// ==================================================================================
// GOOGLE ANALYTICS 4 TRACKING
// Measurement ID: G-264LF5RDJS
// ==================================================================================

(function initializeGoogleAnalytics() {
  const GA4_MEASUREMENT_ID = 'G-264LF5RDJS';

  window.dataLayer = window.dataLayer || [];

  if (typeof window.gtag !== 'function') {
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
  }

  if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
    const script = document.createElement('script');
    script.async = true;
    script.src =
      'https://www.googletagmanager.com/gtag/js?id=' +
      encodeURIComponent(GA4_MEASUREMENT_ID);

    document.head.appendChild(script);
  }

  if (!window.__breezeGoogleTagInitialized) {
    window.gtag('js', new Date());
    window.__breezeGoogleTagInitialized = true;
  }

  window.gtag('config', GA4_MEASUREMENT_ID, {
    send_page_view: false
  });
})();

const BREEZE_GA4_MEASUREMENT_ID = 'G-264LF5RDJS';

// ==================================================================================
// CHECKOUT INIT (BEGIN CHECKOUT)
// ==================================================================================

['checkout-init', 'breeze-checkout-init', 'breeze-initiate-checkout'].forEach(function (eventName) {
  window.addEventListener(eventName, function (event) {
    const params = getBreezeAnalyticsEventData(event, 'Checkout Init');

    if (!params) {
      return;
    }

    try {
      const items = createGA4Items(params.items);
      const userDetails = params.userDetails || params.customer || params.user || {};
      const userData = createGA4UserData(userDetails);
      const currency = params.currency || 'INR';
      const value = toGA4Number(params.totalPrice);

      const ecommerce = {
        currency: currency,
        value: value,
        coupon: params.coupon || '',
        items: items
      };

      window.dataLayer.push({
        event: 'checkout-init',
        event_source: 'breeze',
        user_data: userData,
        user_details: userDetails,
        ecommerce: ecommerce,
        breeze_event_type: 'checkout-init',
        breeze_event_time: new Date().toISOString()
      });

      window.gtag('event', 'begin_checkout', {
        send_to: BREEZE_GA4_MEASUREMENT_ID,
        currency: currency,
        value: value,
        coupon: params.coupon || '',
        items: items,
        user_data: userData,
        breeze_event_type: 'checkout-init',
        breeze_event_time: new Date().toISOString()
      });
    } catch (error) {
      logGA4Error('GA4 checkout-init', error);
    }
  });
});

// ==================================================================================
// ADD SHIPPING INFO
// ==================================================================================

['add-shipping-info', 'breeze-add-shipping-info', 'breeze-initiate-checkout'].forEach(function (eventName) {
  window.addEventListener(eventName, function (event) {
    const params = getBreezeAnalyticsEventData(event, 'Add shipping info');

    if (!params) {
      return;
    }

    try {
      const items = createGA4Items(params.items);
      const userDetails = params.userDetails || params.customer || params.user || {};
      const userData = createGA4UserData(userDetails);
      const currency = params.currency || 'INR';
      const value = toGA4Number(params.totalPrice);

      const ecommerce = {
        currency: currency,
        value: value,
        coupon: params.coupon || '',
        shipping_tier: params.shippingTier || '',
        items: items
      };

      window.dataLayer.push({
        event: 'add_shipping_info',
        event_source: 'breeze',
        user_data: userData,
        user_details: userDetails,
        ecommerce: ecommerce,
        breeze_event_type: 'add_shipping_info',
        breeze_event_time: new Date().toISOString()
      });

      window.gtag('event', 'add_shipping_info', {
        send_to: BREEZE_GA4_MEASUREMENT_ID,
        currency: currency,
        value: value,
        coupon: params.coupon || '',
        shipping_tier: params.shippingTier || '',
        items: items,
        user_data: userData,
        breeze_event_type: 'add_shipping_info',
        breeze_event_time: new Date().toISOString()
      });
    } catch (error) {
      logGA4Error('GA4 add_shipping_info', error);
    }
  });
});

// ==================================================================================
// PAYMENT SCREEN (ADD PAYMENT INFO)
// ==================================================================================

['payment-screen', 'breeze-payment-screen', 'breeze-add-payment-info'].forEach(function (eventName) {
  window.addEventListener(eventName, function (event) {
    const params = getBreezeAnalyticsEventData(event, 'Payment Screen');

    if (!params) {
      return;
    }

    try {
      const items = createGA4Items(params.items);
      const userDetails = params.userDetails || params.customer || params.user || {};
      const userData = createGA4UserData(userDetails);
      const currency = params.currency || 'INR';
      const value = toGA4Number(params.totalPrice);

      const ecommerce = {
        currency: currency,
        value: value,
        coupon: params.coupon || '',
        payment_type: params.paymentMethodType || '',
        items: items
      };

      window.dataLayer.push({
        event: 'payment-screen',
        event_source: 'breeze',
        user_data: userData,
        user_details: userDetails,
        ecommerce: ecommerce,
        breeze_event_type: 'payment-screen',
        breeze_event_time: new Date().toISOString()
      });

      window.gtag('event', 'add_payment_info', {
        send_to: BREEZE_GA4_MEASUREMENT_ID,
        currency: currency,
        value: value,
        coupon: params.coupon || '',
        payment_type: params.paymentMethodType || '',
        items: items,
        user_data: userData,
        breeze_event_type: 'payment-screen',
        breeze_event_time: new Date().toISOString()
      });
    } catch (error) {
      logGA4Error('GA4 payment-screen', error);
    }
  });
});

// ==================================================================================
// ORDER PLACED (PURCHASE)
// ==================================================================================

['order-placed', 'breeze-order-placed', 'breeze-purchase'].forEach(function (eventName) {
  window.addEventListener(eventName, function (event) {
    const params = getBreezeAnalyticsEventData(event, 'Order Placed');

    if (!params) {
      return;
    }

    try {
      const items = createGA4Items(params.items);
      const userDetails = params.userDetails || params.customer || params.user || {};
      const userData = createGA4UserData(userDetails);
      const currency = params.currency || 'INR';
      const value = toGA4Number(params.totalPrice);
      const tax = toGA4Number(params.tax);
      const shipping = toGA4Number(
        params.shippingCharge !== undefined
          ? params.shippingCharge
          : params.shipping
      );

      const ecommerce = {
        transaction_id: String(params.shopOrderId || ''),
        currency: currency,
        value: value,
        tax: tax,
        shipping: shipping,
        coupon: params.coupon || '',
        items: items
      };

      window.dataLayer.push({
        event: 'order-placed',
        event_source: 'breeze',
        user_data: userData,
        user_details: userDetails,
        ecommerce: ecommerce,
        breeze_event_type: 'order-placed',
        breeze_event_time: new Date().toISOString()
      });

      window.gtag('event', 'purchase', {
        send_to: BREEZE_GA4_MEASUREMENT_ID,
        transaction_id: String(params.shopOrderId || ''),
        currency: currency,
        value: value,
        tax: tax,
        shipping: shipping,
        coupon: params.coupon || '',
        items: items,
        user_data: userData,
        customer_type: params.customerType || '',
        payment_type: params.paymentMethodType || '',
        breeze_event_type: 'order-placed',
        breeze_event_time: new Date().toISOString()
      });
    } catch (error) {
      logGA4Error('GA4 order-placed', error);
    }
  });
});

// ==================================================================================
// GA4 UTILITIES
// ==================================================================================

function getBreezeAnalyticsEventData(event, eventName) {
  if (!event || !event.detail || !event.detail.data) {
    console.error(
      eventName + ': invalid event data. Expected event.detail.data.'
    );

    return null;
  }

  return event.detail.data;
}

function createGA4Items(items) {
  if (!Array.isArray(items)) {
    console.error('Invalid GA4 items array:', items);
    return [];
  }

  return items.map(function (item, index) {
    return {
      item_id:
        'shopify_IN_' +
        String(item.id || '') +
        '_' +
        String(item.variant || ''),
      item_name: item.name || '',
      item_brand: item.vendor || '',
      item_category: item.productType || '',
      item_variant: item.variantTitle || String(item.variant || ''),
      coupon: item.discount || '',
      price: toGA4Number(item.price),
      quantity: toGA4Number(item.quantity),
      currency: item.currency || 'INR',
      index: index
    };
  });
}

function createGA4UserData(userData) {
  if (!userData || typeof userData !== 'object') {
    return undefined;
  }

  return {
    email: userData.email || '',
    phone_number: userData.phone || userData.phoneNumber || '',
    address: {
      first_name: userData.firstName || userData.name || '',
      last_name: userData.lastName || '',
      street: userData.address || userData.street || '',
      city: userData.city || '',
      region: userData.state || userData.region || '',
      postal_code: userData.postalCode || userData.zip || userData.zipCode || '',
      country: userData.country || 'IN'
    }
  };
}

function toGA4Number(value) {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
}

function logGA4Error(source, error) {
  console.error(source + ' failed:', error);

  if (error && error.stack) {
    console.error(error.stack);
  }
}